import React from 'react';

import RoleFilter from '/components/adminAccess/roleFilter/RoleFilter';
import { ArrowDownward, ArrowUpward } from '@material-ui/icons';
import CustomTableCell from '/components/adminAccess/customTableCell/CustomTableCell';
import { Typography } from '@material-ui/core';

const HeaderMobile = ({ roleSortToggle, roleSortUp }) => (
  <>
    <CustomTableCell>
      <Typography variant='body1'>Name</Typography>
    </CustomTableCell>
    <CustomTableCell>
      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        <RoleFilter />
        <span style={{ marginTop: 2, marginLeft: '4px', marginRight: '4px' }}>
          <Typography variant='body1'>Role</Typography>
        </span>
        {!roleSortUp ? (
          <ArrowDownward style={{ width: 20, height: 20, opacity: 0.6, cursor: 'pointer' }} onClick={roleSortToggle} />
        ) : (
          <ArrowUpward style={{ width: 20, height: 20, opacity: 0.6, cursor: 'pointer' }} onClick={roleSortToggle} />
        )}
      </div>
    </CustomTableCell>
  </>
);

export default HeaderMobile;
